import { Reveal } from "@/lib/motion";

const SPECS = [
  ["Product", "Tap Review NFC Stand"],
  ["Material", "PVC"],
  ["Finish", "Glossy"],
  ["Size", "Approximately 100 × 150 mm"],
  ["Base", "Approximately 50 mm"],
  ["NFC", "NTAG215"],
  ["Frequency", "13.56 MHz"],
  ["Reprogrammable", "Yes"],
  ["Battery", "Not required"],
  ["Subscription", "None"],
  ["Phone compatibility", "Modern NFC-compatible iPhone and Android devices"],
];

export const Specs = () => (
  <section className="bg-white py-24 md:py-32" data-testid="specs-section">
    <div className="mx-auto max-w-4xl px-6 md:px-12">
      <Reveal>
        <p className="text-overline">Specifications</p>
        <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          The details.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <dl className="mt-12 divide-y divide-line border-t border-line">
          {SPECS.map(([k, v]) => (
            <div
              key={k}
              className="flex flex-col gap-1 py-5 sm:flex-row sm:items-center sm:justify-between sm:gap-8"
            >
              <dt className="text-sm font-medium uppercase tracking-[0.1em] text-ink/50">
                {k}
              </dt>
              <dd className="text-base text-ink sm:text-right sm:max-w-md">{v}</dd>
            </div>
          ))}
        </dl>
      </Reveal>
    </div>
  </section>
);
